<template>
  <div v-if="props.ruta" @click="navigateBack" class="navigateToBack d-flex align-items-center">
    <i class="fa-solid fa-arrow-left"></i>
    <div class="ml-2">{{ $t(`shared.ui.literals.go_back`) }}</div>
  </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n/i18nservice';
import { useRouter } from '@services/routing-services';

const router = useRouter();
const intl = useIntl();

const props = defineProps({
  ruta: String
});

const navigateBack = async () => {
  await router.push(intl.i18Route(props.ruta!));
};
</script>

<style>
.navigateToBack {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1rem;
}

.navigateToBack .ml-2 {
  margin-left: 0.5rem;
}
</style>
